module.exports = __webpack_public_path__ + "static/media/country_by.65885a16.webp";